import React from 'react';
import { useContent, useLanguages } from '../../../hooks/content';
import { Returntext } from '../../../pages/Landings/common/returnText';

const PICKUP_DAY_GROUPS = [
  {
    key: 'weekdays',
    days: ['monday', 'tuesday', 'wednesday', 'thursday', 'friday'],
    fromKey: 'payment_office_day_monday',
    toKey: 'payment_office_day_friday',
    fallback: { ka: 'ორშაბათი - პარასკევი', en: 'Monday - Friday' },
  },
  {
    key: 'weekend',
    days: ['saturday', 'sunday'],
    fromKey: 'payment_office_day_saturday',
    toKey: 'payment_office_day_sunday',
    fallback: { ka: 'შაბათი - კვირა', en: 'Saturday - Sunday' },
  },
];

const WorkingHoursDisplay = ({ workingHours, style }) => {
  const { lang } = useLanguages();
  const { contentManagementData } = useContent();

  const byDay = new Map((workingHours || []).map((w) => [w.day, w]));

  const closedText =
    Returntext(contentManagementData, 'payment_office_closed', lang);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '2px',
        ...style,
      }}
    >

      <div
          style={{
            fontSize: 13,
            lineHeight: 1.5,
            color: '#637381',
            fontWeight: 600,
          }}
        >
          {
            Returntext(contentManagementData, 'payment_office_working_hours_title', lang)
          }
      </div>
      {PICKUP_DAY_GROUPS.map(({ key, days, fromKey, toKey, fallback }) => {
        const entry = days
          .map((d) => byDay.get(d))
          .find(
            (e) =>
              e && e.is_active !== false && e.opens_at && e.closes_at,
          );
        const isClosed = !entry;

        const from = Returntext(contentManagementData, fromKey, lang);
        const to = Returntext(contentManagementData, toKey, lang);
        const dayLabel =
          from && to ? `${from} - ${to}` : fallback[lang] || fallback.en;
        const hoursLabel = isClosed
          ? closedText
          : `${entry.opens_at}–${entry.closes_at}`;

        return (
          <div
            key={key}
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              fontSize: 12,
              lineHeight: 1.5,
              color: '#637381',
              fontWeight: 400,
            }}
          >
            <span>{dayLabel}</span>
            <span
              style={{
                fontVariantNumeric: 'tabular-nums',
                fontStyle: isClosed ? 'italic' : 'normal',
                opacity: isClosed ? 0.75 : 1,
              }}
            >
              {hoursLabel}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default WorkingHoursDisplay;
